webpackJsonp([32],{

/***/ "+skl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("7zGH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0IKf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "26+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var util = {};
var baseurl;
baseurl = "http://119.23.37.215:9099/";
//baseurl ="http://localhost:9099/";

util.ajax = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: baseurl + "xy/",
  timeout: 30000
});
util.picurl = baseurl + "pic/";
util.upurl = baseurl + "xy/upload/pic/";
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),

/***/ "3iZP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+29":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4IG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/axios.js
var axios = __webpack_require__("26+e");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/about.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var about = ({
    data: function data() {
        return {
            index: 1,
            city: 0,
            imglist: [],
            content: '',
            layout: '',
            id: 0
        };
    },

    watch: {
        // '$route' (to, from) {
        //     console.log('to',to);
        //     console.log('from',from);
        //   this.geturl();
        // }
    },
    created: function created() {
        this.geturl();
    },

    methods: {
        geturl: function geturl() {
            var _this = this;

            var id = 0;
            id = this.$route.query.city;
            var title = '';
            if (typeof id === "undefined" || id === "undefined") {
                id = 1;
            }

            if (id == 1) {
                title = "星源简介";
            }
            if (id == 3) {
                title = "研发实力";
            }
            if (id == 4) {
                title = "合作伙伴";
            }
            this.id = id;
            window.document.title = title;
            var param = new URLSearchParams();
            param.append('id', this.id);
            axios["a" /* default */].ajax({
                url: '/us/detail',
                method: 'post',
                params: param
            }).then(function (res) {
                _this.content = res.data.data.info;
                _this.layout = res.data.data.layout;
            }).catch(function (err) {});
        }
    }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/about.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var view_about = ({
    data: function data() {
        return {
            index: 1,
            city: 0,
            imglist: [],
            content: '',
            layout: '',
            id: 0
        };
    },

    watch: {
        // '$route' (to, from) {
        //     console.log('to',to);
        //     console.log('from',from);
        //   this.geturl();
        // }
    },
    created: function created() {
        this.geturl();
    },

    methods: {
        geturl: function geturl() {
            var _this = this;

            var id = 0;
            id = this.$route.query.city;
            var title = '';
            if (typeof id === "undefined" || id === "undefined") {
                id = 1;
            }

            if (id == 1) {
                title = "星源简介";
            }
            if (id == 3) {
                title = "研发实力";
            }
            if (id == 4) {
                title = "合作伙伴";
            }
            this.id = id;
            window.document.title = title;
            var param = new URLSearchParams();
            param.append('id', this.id);
            axios["a" /* default */].ajax({
                url: '/us/detail',
                method: 'post',
                params: param
            }).then(function (res) {
                _this.content = res.data.data.info;
                _this.layout = res.data.data.layout;
            }).catch(function (err) {});
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a7a793","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/about.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navbody"},[_c('div',[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])]),_vm._v(" "),_c('div',{staticClass:"dianchi"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_about = (esExports);
// CONCATENATED MODULE: ./src/view/about.vue
function injectStyle (ssrContext) {
  __webpack_require__("k3lv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30a7a793"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  view_about,
  selectortype_template_index_0_src_view_about,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_view_about = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "55wj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("nnSp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7zGH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3iZP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DiED":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "GyoN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about_xuanyuan_bg1@2x.4e6c557.png";

/***/ }),

/***/ "L8Y5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view = ({
    data: function data() {
        return {
            clientHeight: '', //屏幕高度
            clientWidth: '', //屏幕宽度
            phone: 0
        };
    },
    mounted: function mounted() {
        this.clientHeight = '' + document.documentElement.clientHeight;
        this.clientWidth = '' + document.documentElement.clientWidth;
        window.onresize = function temp() {
            this.clientHeight = '' + document.documentElement.clientHeight;
            this.clientWidth = '' + document.documentElement.clientWidth;
        };
        window.document.title = "星源材质";
    },

    methods: {
        gourl: function gourl(city) {
            if (city == 5) {
                window.location.href = "http://www.senior798.com";
            } else {
                this.$router.push({ path: '/about', query: { city: city } });
            }
        }
    }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_view = ({
    data: function data() {
        return {
            clientHeight: '', //屏幕高度
            clientWidth: '', //屏幕宽度
            phone: 0
        };
    },
    mounted: function mounted() {
        this.clientHeight = '' + document.documentElement.clientHeight;
        this.clientWidth = '' + document.documentElement.clientWidth;
        window.onresize = function temp() {
            this.clientHeight = '' + document.documentElement.clientHeight;
            this.clientWidth = '' + document.documentElement.clientWidth;
        };
        window.document.title = "星源材质";
    },

    methods: {
        gourl: function gourl(city) {
            if (city == 5) {
                window.location.href = "http://www.senior798.com";
            } else {
                this.$router.push({ path: '/about', query: { city: city } });
            }
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-628938a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagebody"},[_c('div',{staticClass:"back",style:({minHeight:_vm.clientHeight+'px',width:_vm.clientWidth+'px'})},[_c('img',{staticClass:"bgimg",style:({minHeight:_vm.clientHeight+'px',width:_vm.clientWidth+'px'}),attrs:{"src":__webpack_require__("GyoN")}}),_vm._v(" "),_c('div',{staticClass:"bg"},[_c('div',{staticClass:"bg1"},[_c('img',{staticStyle:{"position":"absolute","width":"0.78rem","height":"0.81rem","top":"2.24rem","left":"1.12rem","z-index":"100"},attrs:{"src":__webpack_require__("aJEb")},on:{"click":function($event){_vm.gourl(3)}}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.26rem","color":"#439dff","position":"absolute","top":"3.1rem","left":"0.98rem","z-index":"100"},on:{"click":function($event){_vm.gourl(3)}}},[_vm._v("常州星源")]),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","width":"0.58rem","height":"0.81rem","top":"0.76rem","left":"2.14rem","z-index":"100"},attrs:{"src":__webpack_require__("DiED")},on:{"click":function($event){_vm.gourl(2)}}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.26rem","color":"#439dff","position":"absolute","top":"1.64rem","left":"1.9rem","z-index":"100"},on:{"click":function($event){_vm.gourl(2)}}},[_vm._v("合肥星源")]),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","width":"1.04rem","height":"0.81rem","top":"0.76rem","left":"3.76rem","z-index":"100"},attrs:{"src":__webpack_require__("g9Zx")},on:{"click":function($event){_vm.gourl(4)}}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.26rem","color":"#439dff","position":"absolute","top":"1.64rem","left":"3.76rem","z-index":"100"},on:{"click":function($event){_vm.gourl(4)}}},[_vm._v("江苏星源")]),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","width":"0.7rem","height":"0.7rem","top":"2.3rem","left":"4.7rem","z-index":"100"},attrs:{"src":__webpack_require__("qnDW")},on:{"click":function($event){_vm.gourl(5)}}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.26rem","color":"#439dff","position":"absolute","top":"3.1rem","left":"4.6rem","z-index":"100"},on:{"click":function($event){_vm.gourl(5)}}},[_vm._v("公司官网")]),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","width":"1.16rem","height":"1.16rem","top":"2.94rem","left":"2.73rem","z-index":"100"},attrs:{"src":__webpack_require__("Un46")},on:{"click":function($event){_vm.gourl(1)}}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14pt","color":"#439dff","position":"absolute","top":"4.24rem","left":"2.6rem","z-index":"100"},on:{"click":function($event){_vm.gourl(1)}}},[_vm._v("深圳星源")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view = (esExports);
// CONCATENATED MODULE: ./src/view/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("0IKf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-628938a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_view,
  selectortype_template_index_0_src_view,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_view = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./src/router/index.js
var router = __webpack_require__("YaEn");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58e9c184","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("4+29")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/iview/dist/iview.js
var iview = __webpack_require__("BTaQ");
var iview_default = /*#__PURE__*/__webpack_require__.n(iview);

// EXTERNAL MODULE: ./node_modules/iview/dist/styles/iview.css
var styles_iview = __webpack_require__("+skl");
var styles_iview_default = /*#__PURE__*/__webpack_require__.n(styles_iview);

// EXTERNAL MODULE: ./node_modules/vue-light-timeline/index.js
var vue_light_timeline = __webpack_require__("Loyc");
var vue_light_timeline_default = /*#__PURE__*/__webpack_require__.n(vue_light_timeline);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// CONCATENATED MODULE: ./src/main.js










fastclick_default.a.attach(document.body);
vue_esm["default"].use(vue_light_timeline_default.a);
vue_esm["default"].config.productionTip = false;






vue_esm["default"].use(plugins_alert["a" /* default */]);
vue_esm["default"].use(loading["a" /* default */]);
vue_esm["default"].use(plugins_confirm["a" /* default */]);
vue_esm["default"].use(toast["a" /* default */]);

vue_esm["default"].prototype.$msgbox = function (title, msg) {
  this.$vux.alert.show({
    title: title,
    content: msg,
    buttonText: "确定"
  });
};

vue_esm["default"].prototype.$msgloading = function (text, time) {
  var _this = this;

  this.$vux.loading.show({
    text: text
  });
  setTimeout(function () {
    _this.$vux.loading.hide();
  }, time);
};

vue_esm["default"].prototype.$msgtoast = function (text) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
  var position = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'middle';
  var width = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '150px';

  this.$vux.toast.show({
    text: text,
    type: type,
    time: time,
    isshowmask: false,
    position: position,
    width: '170px'
  });
};
vue_esm["default"].use(iview_default.a);
/* eslint-disable no-new */
new vue_esm["default"]({
  router: router["a" /* default */],
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "Un46":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHMAAAB0CAYAAAC2Rg1eAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMjBBMUYyMkVEODkxMUU4OEQzQjg3RjU2MzcxNzk0RiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMjBBMUYyM0VEODkxMUU4OEQzQjg3RjU2MzcxNzk0RiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUyMEExRjIwRUQ4OTExRTg4RDNCODdGNTYzNzE3OTRGIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUyMEExRjIxRUQ4OTExRTg4RDNCODdGNTYzNzE3OTRGIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Hi0XRAAAC8JJREFUeNrsXX1wFOUZ/717d/kgCQFBvmpBBARRiwh2rEAdIETQgtiaUPlOGDsMwhQ64wjjdMg4Y2X8o+BYGSlCQkCqwdIikhQuQIeOthYqFCyQQGlDQWjCEMjlSEKSffs8t0eakEtyye1ddu/e38zm9pK73c3z2+fr3fd9HgEbY9ZO2b/2NkbqOkYJiZFSYJiU6A2BZAGkSNr4lT6aQJuX3nvovYf2Pf79CiFQqguUaBpKElNR8unzwmNXeQi7XGhGgYy7eQtP6hKTpY4pdOFjiJDUMAjkCh33S6HhkObA4QMLxdeKTBOQni+HykZkEoFTSfMmkJB7RFxAAuX0cpi2/UjG7uJMcVORGSTSCmSqqEaGDiyktxMhLXSNArV0MXugYfvEIdifM1k0KDIDkbhFTqSrWUHaN4sITLC8STM09sO4eLxTOE+UKTLZlObKaWRGX6fA5Wmbxh31ROwO6cC6g4tEaUySOS1PztIb8TrtfhdRABKkTj920fZmcZY4FRNkPpMnH25oxEba/T6iEEwqpUibE+KxZt88URmVZFJqkVxZjbVkTlfSWyeiHGR6K+jlNXcW8oSgWDxayEzLkz+iFGMD7d6HGAMJ+HPNhaWRyFdFmLUx8boX75I3WYJYBqU0msAqd5Z435ZkpuXLh1CPArIvj0Dhjun9uEcfvByuIcOwkEk540I68kbyj0mKwlYCP08RQ2bxInHc7GNrZh5MSinScuV60sZtisg2ZAQMp/jhC5LTDy2rmT85Jl0XTiKPSJyrKAsuhSGzu8ydLTZZisz0fJmkN+C3ROQziqZOmkaBtUToG5Ygc+o22QcNKESUjOR0k5ZudGdjeaj5qBaqRioiTfGjy6bl4ZfdFgCxj2TTqog0iVAdKykLWB1xMjlq9Qc7ykeaq6FvpW2VWRElk02CilrDhs3puXJmRAIgHhDgPFLJPKzwaBrGubPEubCR6Ruia8BRNSAQgQhX4MR9At/LyxK1pptZHjT3jbUqIiPjPyUeu6RjfVh8Jj/9MGPQXDNxNJiP1ScR6Ee3V68EINFp7vEtEBAtJbeWaaqZ9T+P/CTUi8ugW2Hx48CteuDtI8DRy8F/d9g9wNhBwJgBwKAUIo9I7BnvM0etHU4d8I2Htirg4g3gGJ3nbIVPOHY0t1UJDoz+bJG4HDKZPEPgugdnEOKD5b49gN/M+b/wy6uBuQXtf2dEH2DWQ8BTg4HUEOfr3agB/nwR+PgUcKnKdoTuKs4WHWpoh9M3eKoHTJgh0D+5pRb1SzbuJBng7poyDHhhNDDqXvMEwpo8YySQPgI4fAHYfgK4bBNSyX9m8CzGA1nC3WWfyZOv/HN2wnXHtcDjZEY3zQbWPG0ukc3hoP84bTjwwQvAy08YftZsOOkcP6AbZ3Av846p6/jVjEIZ32Uy/bPoIjL5ajaZ07enAw/cE5m73eUA5jwK5GeQuR8Tuhln3JtkWJT8F4GVE4DkOFODoQfrr+LVLplZ/7zWiE2H7NlNc9h7k/nNHgfMf4wCskvA6XLgDAVLZRQ4VdUGDpriHMb3BpCrGNgTGJIKjCdHNLR32C939cyd8v29c8W1TpHpn6AcM2CCJgwxtiYZEJN1DUC9bqQ8/BneutF3JtXU4qe0+/OgzSw7W6inIT4CE11GCsQmszuJbGZvV/DiqqDJ5LUfagzGsgMJqcKLV4Iik1dj2XgRT0yAIttVM/fKHh1rpsAKJS7Lo29dOV5ql0y2xb71kQqWR6OxGLkdzfQi0w4LXRV8FnTS9Fx5f5tkkq9coKRkm0hINEjMD0gmF4MA1xBQsBOhCwKSyVU9LFUMQiGYNOXBtG1ybCsyuTyLEo8tI6GpLcjkgklcZ0dJxpbaOaUFmVz5qjsKJimYwuaknMPS2UQmlzBTUrEtkv90EU80kcm16JRMbJxyNhr8aUb+iTFKJLaGjz/t2Vw5IBzVIRUi6DYlRvrIrPfvKNjZzmIEL+bSSCsVmfaPaBOf24nBmlCaGRW4XYdRrJnDlSiiQDkFhjGZvZQoosBtSvTW/AXpFeyPFM4zFZnREQSlsJlVZEZHepKsCfqhJBENimmYWTXnJzqQwGR6lRyiwcqimn2mR4kiKlCtCUVmtGimh59Q24rMyhrgisd45e1GLdCgG4t64nlzGsUqBvUEBqYYC39iJADyOK1uZrmYxVeXgeNXjI0LTnQGvAB2/LeAJ79trMyOVnIpK/E4ue2gFatwXLgO7D0LuM8DtSF03Kqg8K6o1NgSSGtnjzaqnqSGOYa/5jUsRwQ1s8LJ/SOlhdjklcsfHANOXjX/2HxTfHQS+P1p4MVHjGXwZmsqWxI+xydfA7cbIyg4HaVObgRqBRKvkrF/4xBw5N/hPxeTuuME8NlZoy5R+nDyuSFWbiirBPaR9rvPkd+6HXn5uYhHJ3d01Ru7n8wD5yN/Tg6eNnwBbD4KPD3UWALPdQn6BTEmxnWFTlcA//gvcIJ8ecm1bvWXlUXZosLJrXm91xDT8JJpLCw1NgaXkxlAkXBSnOFnHcIwmaxx1XVGBTD+joXgs65ObpiStkVya96BKlszUENm+F+V9rleinnO8qvmj4S+VBTaOi35axOZ3CxbicS+cLoM/nxkctdzJRKbaiXwzR8WiJImMrkdoL+HsoL90KSIWqBfKtgIzVxkczL3K8nYzsZKTcLdmsxk7OamnUpCtvKXRw5ki/+0IrM4U9ykP36qRGQrNvNbWtyW7/KVhGxDZI3L1bJufgsyJw7BfhXV2gQSe4rmi6o2ycyZLPjJ4YdKUraIYre1/tVdiIvHO/RSr6RlYQsrcKp4cevsoxWZhfNEGX14hxKZhZVS4BeBGqcGLB4sHVjHPZGV2CypleeeWoyCwJY3AA4uEqUULe1SorNkFLsuRwg9aDL9X3pTaaflUPbAo9jedkzUBoqzxCkpsFnJz0oBLFb9eryo7zSZjIR4rCEbXaHEaAnzWuReIn7XAdltY988wZMnXlOS7HYia+O0jmvnd9g/052FPPKdnyuJdmsEu65osfhnyGRyPqO5sDTUJyq6bP1eSkVUx0qJM67+WBekT+0YPBOBEtVVIYVhN4DqZpOD7dqcNMJM1jgcyCh6VtQFSXzwSNsqPyJtmtPVa3u4H/Dj7wBeInXr34Bytcy3fXI0LKGsYmsntDh4zNojU25dw1eqEFREtHLHwWzRqW4WWmc+zBOm4UQm3QF1StphDXjOOpwUp3Q+D+0ciheJ4/StuWp0KGwayevfnqM4xRt2Mn2EZonddPcsU5I3XSOrnBLTi7PFha58X+vqid3ZYhNFuGsVBaalIHX04/n9S8TfQzhGaEjbIt+jgEhpaWga2UhMZLLFC+U4WqgX4s7GcgqhNyhKQtLIkIk0RTObaehq0tC3FD2d85FsWonIP5p0Y5iHtK0yi142SwmHoqrjqJWDnVB8ZFjJZKTnypmNum+Gn6qW2U4eyelHV6PWsPnMu3EgS+zVNIyjCz6haAuoPjs0J8abTWRYNPMOFufKhEs61pMfXaoY9Em6hm7w5Z0Za7UMmc0Co0w6C/vRnjEcsZ7RXMjkp0/hPI8W7n+keIkoSHBgtIjF2X4CtZS25bgGYmy4iYyIZt4VHE3TJd4jLR0RA0QW8VSPYGYI2JJMxoxCGV9/Fa/S7moiNSkKaSwjbfyZGYMAlifzDmbulH1rarESEsujobEczzTnCco8r7W96ZBRSWZTgFQgU4UXr+i6b1pKXxuSeIrXfvCSgbZmmscMmU2aulf2qCvHS43AQrqqSZbuTE9pBq+P5GV1vBor0CKemCazOabnyvsbJOaTwBZw+3qLECi5hgAvPecVy3cvdFVkBmOGt8mx3L7e1/VcksYicn1YuGASuKSOhkNc1aN5MQiL5rP2AXc952bZ/h7LY3wdXQWlORKJJvg+nr1fQgIp4VqCXMLsTuUrGw1O2Bs5Ump/ycNgMssjue0gd6sDD/JL2gSS/e2xuIi3lzsM8MZ16bmmOZfC5grKXHiX67XaPqKWalp51OB/AgwA0xu+211yaroAAAAASUVORK5CYII="

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_index__ = __webpack_require__("L8Y5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_about__ = __webpack_require__("4IG6");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);



/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: __dirname,
  routes: [{
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */]
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_3__view_about__["a" /* default */]
  }, {
    path: '/info',
    name: 'info',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wcME")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/infolist',
    name: 'infolist',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Nj9m")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/product',
    name: 'product',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tMtw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/culture',
    name: 'culture',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4Xf5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/news',
    name: 'news',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aoOn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/article',
    name: 'article',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bnxb")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/hr',
    name: 'hr',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Txbr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/jd',
    name: 'jd',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ay6T")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/resume',
    name: 'resume',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+veh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/ux',
    name: 'ux',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qAk5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/author',
    name: 'author',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0hjr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/login',
    name: 'login',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2ZEU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/uppwd',
    name: 'uppwd',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bkN6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/stars',
    name: 'stars',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0vII")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/starinfo',
    name: 'starinfo',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Wsmt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/window',
    name: 'window',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oAdF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/timeline',
    name: 'timeline',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9Hz+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/windowview',
    name: 'windowview',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hNFk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/psq',
    name: 'psq',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HoGU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/qform',
    name: 'qform',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NJ1o")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/guess',
    name: 'guess',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5qlr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/gform',
    name: 'gform',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lGGg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/over',
    name: 'over',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VWGm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/top',
    name: 'top',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yfmE")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/my',
    name: 'my',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PDG/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/myq',
    name: 'myq',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2xRK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/myg',
    name: 'myg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KJ8O")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/mya',
    name: 'mya',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JTHp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/myback',
    name: 'myback',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dFga")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/us',
    name: 'us',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vO88")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/aboutus',
    name: 'aboutus',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vO88")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ "aJEb":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "g9Zx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAABRCAYAAAA+aePEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMjBBMUYxQUVEODkxMUU4OEQzQjg3RjU2MzcxNzk0RiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMjBBMUYxQkVEODkxMUU4OEQzQjg3RjU2MzcxNzk0RiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjlGQUNCQjA5RUQ4OTExRTg4RDNCODdGNTYzNzE3OTRGIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjlGQUNCQjBBRUQ4OTExRTg4RDNCODdGNTYzNzE3OTRGIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+hquxnQAACVJJREFUeNrsnQ1wVNUVx//nvV1CvqBBrEgjA5GhH7Ywgo7I50i+I6ktM0kLAkk2hZZOrYDUcaa2RvoxbRVbscNQx2TzAW1NKtMBCiTZDB20M1ARStQ6joK1I3WEWmoSCWT3vdNzl8UuIcaQj9133+bMvH1v3+d973fPuefcd+99Hmgk+X5eaDEeY8YkAh4MVFIjXC4eHRJZvIdTzp/FEyEb3/xopYHxSABxPKDCHTyu+yxawLgjej2NxZ8SAZDh9AQGe/AM94YDHG9dTv8aBRRnyavlRQKnpPd6BswcP6/Jb+Ab3Q6ILi9k13CDwTjDHuwIlNHxeCes6iB7XjiF4wLji/0k3paf52WxLiMNO5tKqceVGlTk50nEWGEDGzmEY7l+vj/eCXvhLazvD05EkwzRsMUy1ZzrxFs5NfwdZibXAbrIKOVoc8e4EFfTVs2F8tB/ei3HSPonyzFP5fpxUGU4VwGSLLfiiptldMcrQdl1fKdFeE4WvYM5XmmUZLgDyvtzBSAxC1m9vSTBdmvcUmThUVGH5CGdgzGrpwcHc3/Hk90QB/2sj1yYW8VsVBHZQzl5uZ/HviNFHNuYI9BvEE094vXi2f0rqaPPmgLxyqwglvBw3Bljtt2Nv+b5edP4VOzS1YEIF6h5NXyTkCgTMD/6SIkMrG+toCcHe2KVe7kbu/qIYT6Qn+3J12PznmI6H70tp5qrBM4jw36ThDMyqxd7fkRciBMt5XiTiFgbQJe0him3Bvsk1QWRLd1yQ2tbfbTjWk54907OEPOyzrbxkPxN7+ehvWh4sLRlNZ0Ja08jTwh14aTk/E+N+E0TPpTr/FPu8X2Zd8mqHsPElpZyOuRYQJEC+jqyJPZg3BS1w24xT3+XdR2y3InIXHJip2miQwr0Tgrh0zZhjhjExXJAgew7ZoAXf9PwYn6KhZ5ORqOcOzeOD2J3oJLucTSgsJnx81wpMw4N1osahHRJIryiuUlxfRAEi5IxxWlVSFdV9QQq6LCUP9+NYRrS4g0n4hiZUmb6HBkH9RZxDrZLrt6GRBPGOuV5Oh6QkgVZuF8gtSUWH0yWsGCNFoCq7qKQNwnLBNLRhNIi8T6dpEX9vm5QAaWZjnxZbE8kLTrNeFALQEqaS+k/qROxQPy9PySMEjEezq/mWY50s/uT/BqeHQJW06Xab7e/LGufkI75TaXUpQ2gK2odanGH2IOvCKhimX/BlYgIz6dcj4LeVVKOB9RbCvw81bJxNxNKBNgiAUYugtS6cBqKlNOkLaAraiLqeQqHcK8srnSLZhHh8YCPvucKQL3LLEtAiVYtF1iT9FUi8RsMzG2roBcd58UNRZp9dExy3sYJaciUXFgg0980db0NsvFL12lQbyncx0nBd7FbbjhPU1UqbvPRXtdo0FWBbxFdRDpK5Ub/oamp+6GrTFxfEiilD8hh9V0DDy9we24tZ7saUBiSjwICScu21Wxhg+sBhS9sDn/bg5gAIhRl1/EM1wNqKaeXxKsLaOjSEVn4lusBhS9O2KppaFRe0sjJrgc0PhX7ZPaOhs5CxrnOq3tduA5QUylZhgG/pjGRz/WAlJge7NTU5V6c38DTXQ/owCp6XdfX6lYQZa4HFLYWhCYttUhVBI9wfyRHAPIY4e4mgy0L1NunJ03gG/KkGlRr1RgSmppfh4Uj+mycAGh/OZ3MruETqtvINR76umlgbVSb6mr1U/xbnth9ASVSTox42z62w23ZD7lag8IJSUZRuB34wLTmAhmoGnMjZvXV4H3PCvq3KiJikW6bMM71GqQk0ib6HtGkrwmoX0jun/IxcPbI9vWBCjr1CafMj0nCbaS6vgyKljYfPZtJ+KwkbJM4D29EORKHPR4ske1fDvj6hyNRvikF+JIYxUNpCaFB0VJbQaoT8xY1qVhDtGlsy2p6ZaDHd3RjTiz6GUUkNeEARUvzKrpmr8wKoSh2FQpITmhAg4xPvhrDGoXpalwJw0B7CGhvK6P3hzkDuEsKa/nmHiuGsdDVT/S06iztMfHogTIacpt2w22AgjYq4qy+nxGtWhaycCynhrepbqWjGnRZe/ZxUs+7eFsWb3BKmsT7PCcmt2rhNGwbTOtUrQGpAZeOnEaKzWFPKtUK4tuSezc4Ma3yoF+Tnw0SIjS7HpAa5iXYg7MD7U3uKFCEvTJtbK2gN1xbBoVszNARTsTrWyrTK1I+PTaQ8YS0dLNtC4u0DgMuZa5NYgWWCag/i2PxMpl4mVNwVLUb1D8Oskf+RVmMQGXJLCu8bIn568JPZPFhrU2cGq5MZjPdGGCLQ5Cpfxlk4cdwqdj4/xA8WgISe50j9nqJWwFRH69YtAG09iir8Xx+BReL3N/0HD+v0BLQyRN4SO7gFrhc2Mb26OZcWgDK8/PnpAD9PhJD0q0gfl/SyGO0AWQznnLCiFhDlKBMfzQMVHg9mGV68SXTxG2S8TYQoTmy/bL7PedcF9ZGPDuHOwZ1fKsay1vrwv/Sq/uC/l7V59XzNDuEKjHjK8N9YgmHZf87nQ/Iz/eJXd6qNSATSwPlNKAOa/m1fItlo05pkWhZluNN3FgDu9RgEjoD8jBeHei+zeX0akYa5qmuOVYIX9eiNls1r83x4z6oIaQZyboBMoGilkraf83Wo54/r4WToIZQbvPRVvJgjmiTduWRbSJlMMcFVtNrWtUkqATfPBNzJdFPJIjLrV9d3NO3UbC1kh4QTdocbjivgwVQw1knCqDLIibvEdPA7eKO/kCmn6thlR1K578eDw4PAa47JLuG/yL6NM+BHsLKtnLamXAa1Ifs/ZggsSMuplCuKa7ymqHAcRUgr3nlyCWquZNJKJFofPyENKTCg3myblfM+DA2t/romWEov9wjqgmuROCrZHGqwMhpraCrhj/LreHlso9/JOv25KGezzRwXaQTwCig3qI+jNvfOKN5fs617LDGjcj3KZRZzZqJicrjTDg3eyDySYPAtlRQq0T360au5gPjTrXjNwkZBw2XtFRSteT0X4/gJXIKd3DmKKAhSEYaHhBILw3zaYNyzqeTkjBr/0oa8jA3hASX8EcWgTKPFw1J4/Aef4ikixcwwwZmq80y3aVM1gBO9Z48zMYxY7Fl37309jA6HKPSn6j+rue6MRMW5svfBQJLzTOjoDwndqhpQTkODfWjjKMyXFpXz1PUl8rUlzJH+lr/E2AAL4oyHL5RsNIAAAAASUVORK5CYII="

/***/ }),

/***/ "k3lv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kllH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')},"on-show":function($event){_vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("55wj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nnSp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qnDW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("kllH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uj2L":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/b1.0be459f.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d899b46d88b9c73ea91d.js